import validate from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/vsts/work/1/s/packages/admin-dashboard/middleware/auth.global.ts";
import redirects_45global from "/home/vsts/work/1/s/packages/admin-dashboard/middleware/redirects.global.ts";
import manifest_45route_45rule from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}